import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ArtificialIntelligence = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Machine Learning & AI</h6>
          <hr />
          <h1 className="banner-title">
            Optimize Performance with Business <br /> Intelligence Solutions
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the video element */}
        <video className="banner-video" autoPlay muted loop playsInline>
          <source src="./assets/img/ai.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h6 className="col_yell">Machine Learning and AI</h6>
              <h2>
                Combining Human Ingenuity with Machine Learning and AI to
                Transform Businesses
              </h2>
              <p>
                Machine Learning and AI are reshaping the landscape of business,
                driving innovation and operational excellence. At DataFluent
                Analytics, we help businesses unlock the power of these
                technologies, crafting custom solutions that balance
                cutting-edge innovation with risk management. Our tailored AI
                and machine learning architectures are designed to meet the
                unique needs of each industry, providing the guardrails that
                safeguard both businesses and customers.
              </p>
            </div>
            {/* <div className="col-md-6">
              <img
                src="https://img.freepik.com/free-photo/programmer-doing-server-examination_482257-75832.jpg?uid=R61343051&ga=GA1.1.1538958416.1730788905"
                alt="Data Engineering"
                className="img-fluid"
              />
            </div> */}
          </div>
        </div>
      </section>

      {/* AI Roadmap Section */}
      <section id="ai-roadmap" className="ai-roadmap py-5 bg-dark text-white">
        <div className="container">
          <h2 className="text-center mb-4">Our Approach</h2>
          <div className="row">
            {/* Step 1 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-lightbulb fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Ideation</h5>
              <p>
                Identify opportunities where AI can bring measurable value to
                your business processes.
              </p>
            </div>

            {/* Step 2 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-search fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Feasibility Analysis</h5>
              <p>
                Evaluate data readiness, technical feasibility, and ROI for AI
                implementation.
              </p>
            </div>

            {/* Step 3 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-database fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Data Strategy</h5>
              <p>
                Develop a robust strategy for data collection, storage, and
                preprocessing.
              </p>
            </div>

            {/* Step 4 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-cogs fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Model Development</h5>
              <p>
                Design, train, and test machine learning models tailored to your
                business needs.
              </p>
            </div>

            {/* Step 5 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-plug fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Integration</h5>
              <p>
                Seamlessly integrate AI solutions into existing workflows and
                systems.
              </p>
            </div>

            {/* Step 6 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-chart-line fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Performance Monitoring</h5>
              <p>
                Continuously monitor AI performance and refine models for
                improved accuracy.
              </p>
            </div>

            {/* Step 7 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-shield-alt fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Ethics & Compliance</h5>
              <p>
                Ensure AI usage aligns with ethical standards, privacy
                regulations, and fairness principles.
              </p>
            </div>

            {/* Step 8 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-users fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>User Training</h5>
              <p>
                Educate stakeholders and end-users on effectively leveraging
                AI-driven solutions.
              </p>
            </div>

            {/* Step 9 */}
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-trophy fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Scaling AI</h5>
              <p>
                Expand AI capabilities across other business units for maximum
                impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AI for Industries Section */}
      <section
        id="ai-industries"
        className="ai-industries py-5 bg-light text-dark"
      >
        <div className="container-xl">
          <h2 className="text-left mb-2">Our AI Solutions for Industries</h2>
          <p className="text-left mb-5">
            Transforming industries with tailor-made AI solutions that drive
            efficiency, innovation, and growth.
          </p>
          <div className="row">
            {/* Healthcare */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-heartbeat fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Healthcare</h5>
                <p>
                  Enhance diagnostics, optimize patient care, and streamline
                  hospital operations using AI-powered solutions.
                </p>
              </div>
            </div>

            {/* Retail */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-shopping-cart fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Retail</h5>
                <p>
                  Boost customer engagement, predict trends, and optimize
                  inventory with AI-driven analytics.
                </p>
              </div>
            </div>

            {/* Finance */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-chart-line fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Finance</h5>
                <p>
                  Automate fraud detection, enhance risk management, and improve
                  financial forecasting with cutting-edge AI.
                </p>
              </div>
            </div>

            {/* Manufacturing */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-industry fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Manufacturing</h5>
                <p>
                  Implement predictive maintenance, optimize production
                  processes, and ensure quality control with AI.
                </p>
              </div>
            </div>

            {/* Education */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-graduation-cap fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Education</h5>
                <p>
                  Personalize learning experiences, track progress, and automate
                  administrative tasks using AI tools.
                </p>
              </div>
            </div>

            {/* Logistics */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-truck fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Logistics</h5>
                <p>
                  Optimize route planning, improve supply chain visibility, and
                  enable real-time tracking with AI integration.
                </p>
              </div>
            </div>

            {/* Energy */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-bolt fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Energy</h5>
                <p>
                  Monitor energy usage, predict equipment failure, and support
                  sustainable practices with AI solutions.
                </p>
              </div>
            </div>

            {/* Real Estate */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-building fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Real Estate</h5>
                <p>
                  Enhance property recommendations, predict market trends, and
                  automate property management with AI tools.
                </p>
              </div>
            </div>

            {/* Automotive */}
            <div className="col-12 col-md-4 d-flex align-items-start mb-4 p-3 border rounded card-hover">
              <i
                className="fa fa-car fa-3x text-primary me-3"
                aria-hidden="true"
              ></i>
              <div>
                <h5>Automotive</h5>
                <p>
                  Enable autonomous driving, enhance manufacturing, and improve
                  vehicle safety with AI advancements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr />

      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                {/* <h6 className="">Benefits</h6> */}
                <h2 className="">Ready to Transform Your Data?</h2>
                <p className="mt-3">
                  Let’s discuss today to explore how we can help your business
                  harness the power of data engineering
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArtificialIntelligence;
